/* @ngInject */

export default () => {
  return {
    restrict: 'A',
    link(scope, el) {
      el.on('keypress', (event) => {
        if (event.charCode === 64 || event.charCode === 16) {
          // to allow numbers
          return false;
        }
        if (event.charCode >= 48 && event.charCode <= 57) {
          // to allow numbers
          return true;
        }
        if (event.charCode >= 96 && event.charCode <= 105) {
          // to allow numpad number
          return true;
        }
        if ([13, 27, 37, 38, 39, 40, 46].indexOf(event.charCode) > -1) {
          // to allow backspace, enter, escape, arrows, dot
          return true;
        }
        event.preventDefault();
        // to stop others
        return false;
      });
    }
  };
};
